import { ExtendedTheme, Select, Option } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';
import { AccountsQueryParams } from '../../hooks/useAccountsQuery';

interface Props {
  options: Option[];
  selected: Option[] | null;
  onChange: (option: Option[] | null) => void;
  loadOptions?: (params?: AccountsQueryParams) => Promise<any> | void;
}

const useStyles = makeStyles((_: ExtendedTheme) =>
  createStyles({
    select: {
      width: 320
    }
  })
);

export const ToolbarAccountSelect = ({ options = [], selected, onChange, loadOptions }: Props) => {
  const classes = useStyles();
  const props = loadOptions ? { loadOptions: (searchString: string) => loadOptions({ searchString }), defaultOptions: options } : { options };

  return <Select className={classes.select} value={selected} placeholder="Select accounts…" onChange={onChange} multi {...props} />;
};
